export default __webpack_public_path__ + "static/media/TorpedoOpen.9a0000f2.jpg";